import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { IS_WEB } from '../../lib/appConstants';

import { FONT_FAMILY, BASE_COLOR, FONT_FAMILY_BOLD, pOrT } from '../styleConstants';

const styles = StyleSheet.create({
  base: {
    fontFamily: FONT_FAMILY,
    fontSize: pOrT(12, 13),
    color: BASE_COLOR,
  },
  bold: {
    fontWeight: IS_WEB ? 600 : undefined,
    fontFamily: FONT_FAMILY_BOLD,
  },
});

type Props = {
  style?: any;
  children?: any;
  bold?: boolean;
  selectable?: boolean;
};

const TextWrapper = ({ style, bold, selectable, children }: Props) => (
  <Text style={[styles.base, bold && styles.bold, style]} selectable={selectable}>
    {children}
  </Text>
);

export default TextWrapper;
